module.exports = __webpack_public_path__ + "img/pexels-scott-webb-532571.64e5a795.jpg";